/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface ILocalizedTextDisplayModel {
  localeCode?: null | string;
  text?: null | string;
}
export class LocalizedTextDisplayModel extends BaseModel implements ILocalizedTextDisplayModel {
  localeCode?: null | string;
  text?: null | string;
}
class BaseLocalizedTextDisplayModelFormGroup extends FormGroup {
  private static _instance: LocalizedTextDisplayModelFormGroup;
  
  public static get Instance(): LocalizedTextDisplayModelFormGroup {
    this._instance = new LocalizedTextDisplayModelFormGroup({
      localeCode: new FormControl(null),
      text: new FormControl(null),
    });

    return this._instance;
  }
}


export class LocalizedTextDisplayModelFormGroup extends BaseLocalizedTextDisplayModelFormGroup {
  public get LocaleCode(): FormControl {
    return this.controls["localeCode"] as FormControl;
  }
  public get Text(): FormControl {
    return this.controls["text"] as FormControl;
  }
  

}

export module LocalizedTextDisplayModelForm
  {
    export class FormFields
    {
      static _localeCode: string = "localeCode";
      static _text: string = "text";
    }
  }

